export const translation_en = (location: string) => {
    return (
        {
            messages: {
                "language": `${location} English`,


                // # Logic
                "cityID": "2",
                "modal-class": "none",
                "ogLocale": "en_us",
                "page.lang": "en-CA",

                // # Header
                // #---- - SEO
                "altTag.logoImage": "Andmar Eco-Energy Long Logo",
                "altTag.roundLogo": "Andmar Eco-Energy Round Logo",
                "altTag.CtaButton": "Schedule Appointment Button",
                "altTag.menuCtaButtonRound": "Schedule Appointment Button Round",
                // #------
                "nav.homepage": "Home",
                "nav.solutions": "Solutions",
                "nav.resources": "Resources",
                "nav.portfolio": "Portfolio",
                "nav.contact-us": "Contact",
                "nav.governmentsIncentives": "Governments Incentives",
                "nav.referrals": "Referral Program",
                "nav.faq": "FAQ",
                "nav.careers": "Careers",
                "nav.financing": "Financing",
                "nav.ctabutton": "navCtaButtonEn",

                // # Footer
                "cta-text.title": "Start saving today!",
                "cta-text.text": `Book a FREE Estimate and have one of our ${location} Representative to guide you through the program details.`,
                "footer-cta-button": "SCHEDULE NOW!",

                "contact-info.title": "CONTACT INFO",
                "contact-info.telephone-tag": "Phone: ",
                "contact-info.tollfree-tag": "Toll Free: ",
                "contact-info.tollfree-number": "1-800-310-6108",
                "contact-info.email-tag": "Email: ",

                "hours.title": "OPENING HOURS",
                "hours.week-tag": "Monday to Friday: ",
                "hours.week-hours": "8h00-18h00",
                "hours.saturday-tag": "Saturday : ",
                "hours.saturday-hours": "8h00-12h00",
                "hours.sunday-tag": "Sunday : ",
                "hours.sunday-hours": "Closed",
                "footer-text": "Residential heat pump specialist! We provide green solutions and outstanding comfort to homeowners.",
                "footer-copyright": `© ${new Date().getFullYear()}  Andmar Eco-Energy ${location}`,


                // # Home Page
                // #----- Page SEO
                "homepage.title": `Andmar Eco-Energy ${location} - Homepage`,
                "homepage.meta-description": `Andmar Eco-Energy ${location} provides green solutions and outstanding comfort to homeowners`,
                "homepage.meta-keywords": `Andmar ${location} Heat Pump Ductless Mini-Split Electrical Ducted`,
                "homepage.meta-robots": "index, follow, notranslate",
                "homepage.canonical": "https://www.andmar.ca/edmundston/en/",
                "homepage.alternateHrefLangEn": "https://www.andmar.ca/edmundston/en/",
                "homepage.alternateHrefLangFr": "https://www.andmar.ca/edmundston/fr/",

                "altTag.GirlHeatPumpImage": `Andmar Eco-Energy ${location} Home Page Local Picture`,
                "altTag.HeatPumpIconLImage": "Heat Pump Icon",
                "altTag.HeatPumpIconSImage": "Heat Pump Icon",
                "altTag.GrillIconLImage": "Ducted Heat Pump Grill Icon",
                "altTag.GrillIconSImage": "Ducted Heat Pump Grill Icon",
                "altTag.FanIconLImage": "Heat Pump Blower Fan Icon",
                "altTag.FanIconSImage": "Heat Pump Blower Fan Icon",
                "altTag.SnowFlakeIconLImage": "Heat Pump Cooling Icon",
                "altTag.SnowFlakeIconSImage": "Heat Pump Cooling Icon",
                "altTag.CompanyEmployeeImage": `Andmar Eco-Energy ${location} Employee Picture`,
                // #----- Page SEO /
                
                "PresentationImage":"EdmundstonPresentation",
                "home.maintext1": "RESIDENTIAL HEAT PUMP SPECIALIST",
                "home.maintext2": "Andmar Eco-Energy provides green solutions and outstanding comfort to homeowners.",

                "attribute1.title": "EXPERTISE",
                "attribute1.text": "Specialization at the residential field",
                "attribute2.title": "QUALITY",
                "attribute2.text": "Use the best materials, workmanship and qualified professionals for your home",
                "attribute3.title": "SATISFACTION",
                "attribute3.text": "Provide flexibility & work in a collaborative effort to ensure the project completion",
                "attribute4.title": "DEDICATION",
                "attribute4.text": "Spark a keen interest for green energy, prosperity and comfort in every home",

                "why-andmar.title": "Andmar Eco-Energy",
                "why-andmar.text1": "Andmar Eco-Energy is a residential heat pump specialist. We provide green solutions and outstanding comfort to homeowners.",
                "why-andmar.text2": "Our team is based on the belief that our customers needs are of the utmost importance. Our Certified Technicians show up neat and clean, treat your home as if it was our own and takes affinity to details. We offer flexibility and collaborative effort to ensure complete satisfaction.",
                "why-andmar.text3": "We appreciate the opportunity to earn your trust and provide the best service in the industry.",
                "why-andmar.signature": "Management Team",

                "solutions": "Solutions",
                "solutions1.title": "Ductless Heat Pump",
                "solutions1.text": "Ductless heat pumps reduce the cost of heating, provide air conditioning and are also an excellent complement for existing heating systems.",
                "solutions2.title": "Ducted Heat Pump",
                "solutions2.text": "Ducted Heat Pump provide flexibility to heat or cool every room in your home.",
                "solutions3.title": "Heat Pump Maintenance",
                "solutions3.text": "Regular maintenance of your heating and cooling system is the key to longevity, efficiency and air quality.",
                "solutions4.title": "Electrical Upgrade",
                "solutions4.text": "The electrical panel controls all the electricity in your home. Make sure it is up to code with an electrical panel upgrade.",

                "why-our-team.title": "Why Our Team",
                "why-our-team.text": "Our team is based on the belief that our customers needs are of the utmost importance.",

                "areas-we-serve": "Areas We Serve",
                "activeArea": "Active Area",
                "comingSoonArea": "Coming Soon",

                "citySelectedMarker": `${location}`,

                // # Solutions - Page
                // #----- Page SEO
                // #-----
                "solutionsPage.title": `Solutions - Andmar Eco-Energy ${location}`,
                "solutions.maintext1": "Solutions",

                "solutions.maintext2": `Our Solutions for the ${location} area`,
                "solutions.companyDescription": `Andmar Eco-Energy ${location} is a residential heat pump specialist. We provide green solutions and outstanding comfort to homeowners.`,

                "solutionsCard1.title": "Ductless Heat Pump",
                "solutionsCard1.Description": "Ductless heat pumps offer air cooling, heat savings and dehumidification in many retrofit applications. They are also a great compliment for existing electric or hot water baseboard heating systems.",

                "solutionsCard2.title": "Ducted Heat Pump",
                "solutionsCard2.Description": "Ducted Heat Pump provide you with the flexibility to heat or cool every room in your home. Your home can be zoned to maximise energy efficiency and you can customise it to suit your lifestyle.",

                "solutionsCard3.title": "Heat Pump Maintenance",
                "solutionsCard3.Description": "Regular maintenance of your heating and cooling system is the key to longevity, efficiency and air quality.",

                "solutionsCard4.title": "Electrical Upgrade",
                "solutionsCard4.Description": "The electrical panel controls all the electricity in your home. Make sure it is up to code and up to speed with an electrical panel upgrade.",

                "solutionsCard5.title": "Heat Recovery Ventilator",
                "solutionsCard5.Description": "Heat Recovery Ventilator ventilate your home while retaining the energy used for heating and cooling. It eliminate excess humidity, airborne pollutants, protect the structure of your home and your family's health.",



                // # Ductless Heat Pump - Page
                // #----- Page SEO
                "ductlessHeatPumpPage.title": `Andmar Eco-Energy ${location} - Ductless Heat Pump Solutions`,
                "ductlessHeatPumpPage.meta-description": `LG Ductless Heat Pump solutions for the ${location} Region. Heat and Cool at a fraction of the cost.`,
                "ductlessHeatPumpPage.meta-keywords": `Andmar ${location} LG Heat Pump Ductless Saving Mini-Split Electrical Air conditioner Heating Cooling Financing`,
                "ductlessHeatPumpPage.meta-robots": "index, follow, notranslate",
                "ductlessHeatPumpPage.canonical": "https://www.andmar.ca/edmundston/en/solutions/ductless-heat-pump/",
                "ductlessHeatPumpPage.alternateHrefLangEn": "https://www.andmar.ca/edmundston/en/solutions/ductless-heat-pump/",
                "ductlessHeatPumpPage.alternateHrefLangFr": "https://www.andmar.ca/edmundston/fr/solutions/thermopompe-murale/",

                "altTag.LGPrestigeImage": "LG Prestige Ductless Heat Pump Image",
                "altTag.LGGlossWhiteImage": "LG Gloss White Ductless Heat Pump Image",
                "altTag.LGMirrorImage": "LG Mirror Ductless Heat Pump Image",
                "altTag.LGCassetteImage": "LG Cassette Ductless Heat Pump Image",
                "altTag.LGMultiFImage": "LG Multi F Ductless Heat Pump Image",
                "altTag.MoneyBagSImage": "Affordable Money Bag Icon",
                "altTag.MoneyBagLImage": "Affordable Money Bag Icon",
                "altTag.ApprovalSignSImage": "Comfort Approval Icon",
                "altTag.ApprovalSignLImage": "Comfort Approval Icon",
                "altTag.EvolutionSImage": "Flexibility Icon",
                "altTag.EvolutionLImage": "Flexibility Icon",
                "altTag.BulbSImage": "Eco-Friendly Icon",
                "altTag.BulbLImage": "Eco-Friendly Icon",
                "altTag.LGLogoImage": "LG Logo",
                "altTag.LGWarrantyImage": "LG Warranty Image",
                "altTag.MoneyBillImage": "Cash Payment Image",
                "altTag.MoneyBagImage": "Financing Payment Image",


                // #----- /
                "ductless-heat-pump.title": `Ductless Heat Pump - Andmar Eco-Energy ${location}`,
                "ductless-heat-pump.maintext1": "Ductless Heat Pump",

                "jump-menu.title1": "MODELS",
                "jump-menu.title2": "WHY DUCTLESS",
                "jump-menu.title3": "WHY LG",
                "jump-menu.title4": "PAYMENT OPTIONS",

                "models": "Models",
                "model.title1": "LG PRESTIGE",
                "model.text1": "Highly energy efficient ductless heat pump.",
                "model.title2": "LG GLOSS WHITE",
                "model.text2": "LG Gloss White provides powerful, efficient heating and cooling, many with Energy Star ratings.",
                "model.title3": "LG MIRROR",
                "model.text3": "Experience true individual comfort. LG MIRROR is the perfect solution to a variety of installation challenges.",
                "model.title4": "LG CEILING CASSETTE",
                "model.text4": "LG ceiling cassette air conditioners make it easy to keep your business cool – no matter what the temperature outside may be.",
                "model.title5": "LG MULTI F",
                "model.text5": "LG Multi F units support up to 4 indoor units for maximum design flexibility.",

                "why-ductless.maintitle": "Ductless Heat Pump Benefits",
                "why-ductless.title1": "Affordable",
                "why-ductless.text1": "Reduce Heating Cost by up to 50%",
                "why-ductless.title2": "Comfort",
                "why-ductless.text2": "Provide Heating, AC, Dehumidification and Air Filtration",
                "why-ductless.title3": "Flexibility",
                "why-ductless.text3": "Great complement for existing Heating Systems",
                "why-ductless.title4": "ECO-Friendly",
                "why-ductless.text4": "Reduce the Global CO2 Emissions",

                "why-lg.maintitle": "LG Ductless Heat Pump",
                "why-lg.title1": "THE MOST RECOGNIZED HEAT PUMP",
                "why-lg.text1": "LG is a world leader in ductless products and offer what no other company can provide; Best return on investment, aesthetically pleasing, environmentally friendly and dependable ductless mini-split systems.",
                "why-lg.title2": "EFFICIENCY",
                "why-lg.text2": "LG offers some of the most energy efficient ductless mini-split and some of the quietest. With built in features such as Jet Cool, 4-Way Swing and Power Heating your LG heat pump will provide your home with a comfortable environment year round.",

                "why-andmar.maintitle": "Andmar Eco-Energy",
                "why-andmar.text": "We provide green solutions and outstanding comfort to homeowners.",


                "payment-options.title": "Payment Options",
                "payment-options.text": "Check out our payment options",

                "payment-option1.title": "CASH",
                "payment-option1.attributetag1": "Payment Methods",
                "payment-option1.attributetext1": "E-Transfer, Cheque, Credit Card",
                "payment-option1.attributetag2": "Payment",
                "payment-option1.attributetext2": "Initial Payment Only",
                "payment-option1.attributetag3": "Terms",
                "payment-option1.attributetext3": "NA",
                "payment-option1.attributetag4": "Reduced Upfront Cost",
                "payment-option1.attributetext4": "NA",
                "payment-option1.attributetag5": "No Early Payment Penalties",
                "payment-option1.attributetext5": "NA",
                "payment-option1.attributetag6": "Qualified And Experienced Installation",
                "payment-option1.attributetext6": "",
                "payment-option1.cta-button": "Book FREE estimate",

                "payment-option2.title": "FINANCING*",
                "payment-option2.attributetag1": "Payment Methods",
                "payment-option2.attributetext1": "Direct Debit",
                "payment-option2.attributetag2": "Payment",
                "payment-option2.attributetext2": "As low as $12/Week",
                "payment-option2.attributetag3": "Terms",
                "payment-option2.attributetext3": "Up to 10 Years",
                "payment-option2.attributetag4": "Reduced Upfront Cost",
                "payment-option2.attributetext4": "",
                "payment-option2.attributetag5": "No Early Payment Penalties",
                "payment-option2.attributetext5": "",
                "payment-option2.attributetag6": "Qualified And Experienced Installation",
                "payment-option2.attributetext6": "",
                "payment-option2.attributetag7": "*Subject to Credit Approval",

                "payment-option2.cta-button": "Book FREE estimate",

                // # Portfolio - Page
                "portfolio.title": `Portfolio - Andmar Eco-Energy ${location}`,

                "portfolio.maintext1": "Featured Projects",

                // # Referral - Page
                "referral.title": `Referral Program - Andmar Eco-Energy ${location}`,
                "referral.maintext1": "Referral Program",

                "referral.subTitle1":"Receive",
                "referral.subTitle2":"and make your",
                "referral.subTitle3":" FRIENDS",
                "referral.subTitle4":" save",
                "referral.subTitle5":"on their",
                "referral.subTitle6":" PURCHASE",

                "referral.text2":"At Andmar Eco-Energy we appreciate the trust you place in our company, and consider it a high compliment when our customers refer our services to their families and friends. We are always pleased to receive referrals that allow us to make your friends and family part of our community of satisfied customers. We know that the best way to find a good contractor is to ask around and find someone who has provided excellent work for a friend or family member. We’re honored by the number of customers who refer us to their friends, and we’re grateful for your referral as well. Thank you for your business!",
                "referral.text3":"We are grateful for your partnership, and as a way of saying thank you, we offer the referral incentive as follows:",
                "referral.termsTitle":"Terms and Conditions",
                "referral.termsCondition1":"One referral card per purchaser.",
                "referral.termsCondition2":"No limit to the number of friends you can refer.",
                "referral.termsCondition3":"Referrers receive a $50 gift card and the purchaser receives a $50 rebate on his first purchase invoice.",
                "referral.termsCondition4":"Applies only for the purchase of a heat pump from Andmar Eco-Energy.",
                "referral.termsCondition5":"Can only be accepted by an Andmar Eco-Energy representative, during the day of the estimate.",
                "referral.termsCondition6":"Referrers must be registered with Andmar Eco-Energy.",
                "referral.termsCondition7":"Referred must be a new customer to Andmar Eco-Energy.",
                "referral.termsCondition8":"One referral per person.",
                "referral.incitativeText":"Have someone in mind who could use some assistance with heating and cooling? Let us know and make your friends happy.",


                // # Government - Grant - Incentive - Page
                "grant.title": `Governments Grants Incentives - Andmar Eco-Energy ${location}`,
                "grant.maintext1": "Governments Incentives",
                
                "grant.p1.1": "Homeowners in New-Brunswick have the opportunity to improve their home's energy efficiency and reduce their energy bills through the ",
                "grant.name2": "Total Home Energy Savings program.",
                //"grant.name1": "Canada Greener Home Grant",
                //"grant.p1.2": " and the Provincial ",
                
                "grant.p2.1": "To take advantage of this program, homeowners must register for the Total Home Energy Savings Program at ",
                "grant.link1": "https://www.saveenergynb.ca/en/save-energy/residential/total-home-energy-savings-program/",
                "grant.p2.2": " or by calling 1-800-663-6272.",
                //"grant.p3.1": "The Canada Greener Homes Grant is a separate program in which you can also apply at ",
                //"grant.link2": "https://www.nrcan.gc.ca/energy-efficiency/homes/canada-greener-homes-grant/23441",
                //"grant.p3.2": " or by calling 1-833-674-8282.",
                "grant.p4": "It's important to note that the Total Home Energy Savings Program is a provincial government initiative. As such, they are the only authority that can provide accurate details on grant amounts and eligibility criteria. This ensures that homeowners receive reliable and official support throughout the process of making their homes more energy efficient.",
                "grant.p5": "Thank you for choosing Andmar Eco-Energy.",
                "grant.p6": "Thank you for choosing Andmar Eco-Energy.",
                
                "grant.y2025m1.p1": "There are three government programs available to homeowners in New-Brunswick, aimed at enhancing energy efficiency and reducing heating costs:",
                "grant.y2025m1.at": "at ",
                "enhancedEnergySavingImage": "enhancedEnergySavingEN",
                "altTag.enhancedEnergySaving": "Enhanced Energy Saving Program Image",
                "grant.y2025m1.p2": "This program assists homeowners with a combined annual household income of $70,000 or less. Eligible participants may qualify for no-cost efficiency upgrades, including insulation for basements, attics, and walls, ventilation improvements for air quality or humidity issues, and heating system upgrades. These enhancements aim to reduce energy consumption and improve home comfort.",
                "grant.y2025m1.p3": "To take advantage of this program, homeowners must register for the ",
                "grant.y2025m1.p3.1": "Enhanced Energy Savings Program ",
                "grant.y2025m1.link.p3": "https://www.saveenergynb.ca/en/for-home/enhanced-energy-savings-program/ ",
                "grant.y2025m1.p3.2": "or by calling 1-800-663-6272.",

                "totalHomeEnergySavingImage": "totalHomeEnergySavingEN",
                "altTag.totalHomeEnergySaving": "Total Home Energy Saving Program Image",
                "grant.y2025m1.p4": "This initiative helps homeowners switch from oil-based heating to electric heat pumps. In New-Brunswick, the federal Oil to Heat Pump Affordability Program combines with the Total Home Energy Savings Program. The eligible participants can receive up to $15,000 for the purchase and installation of cold-climate heat pump systems. This funding also covers necessary electrical and mechanical upgrades, safe removal of oil tanks, and the installation of backup electric heating systems if needed.",
                "grant.y2025m1.p5": "To take advantage of this program, homeowners must register for the ",
                "grant.y2025m1.p5.1": "Total Home Energy Savings Program ",
                "grant.y2025m1.link.p5": "https://www.saveenergynb.ca/en/save-energy/residential/total-home-energy-savings-program/",
                "grant.y2025m1.p5.2": " or by calling 1-800-663-6272.",
                
                "greenerHomeLoanImage": "greenerHomeLoanEN",
                "altTag.greenerHomeLoan": "Greener Home Loan Image",
                "grant.y2025m1.p6": "A federal program offering interest-free loans up to $40,000 to help Canadian homeowners undertake major home retrofits that increase energy efficiency. To qualify, homeowners must be eligible for and apply for the Canada Greener Homes Grant or the equivalent provincial program, complete a pre-retrofit evaluation, and select at least one eligible retrofit recommended by an energy advisor.",
                "grant.y2025m1.p7": "To take advantage of this program, homeowners must register for the ",
                "grant.y2025m1.p7.1": "Greener Home Loan Program ",
                "grant.y2025m1.link.p7": "https://natural-resources.canada.ca/energy-efficiency/home-energy-efficiency/canada-greener-homes-initiative/canada-greener-homes-loan ",
                "grant.y2025m1.p7.2": "or by calling 1-833-674-8282.",
               

                // # Contact Us - Page
                "contact-us.title": `Contact Us - Andmar Eco-Energy ${location}`,
                "contact-us.maintext1": "Contact Us",

                "card1.title": "Contact Info",

                "card1.attributetext3": "Send us an email",
                "card1.attributetext4": "edmundston@andmar.ca",
                "card1.attributetext5": "Give us a call",
                "card1.attributetext6": "1-506-501-2241",

                "card2.title": "Drop us a line",
                "card2.attributetext1": "Your Name",
                "card2.attributetext2": "Email",
                "card2.attributetext3": "Message",
                "card2.attributetext4": "Phone",
                "card2.send-button": "SEND MESSAGE",
                "card2.send-success": "Thanks for emailing us! Your message has been submitted.",

                "hours.tilte": "Opening Hours",
                "hours.attributetag1": "MONDAY",
                "hours.attributetext1": "8h00-18h00",
                "hours.attributetag2": "TUESDAY",
                "hours.attributetext2": "8h00-18h00",
                "hours.attributetag3": "WEDNESDAY",
                "hours.attributetext3": "8h00-18h00",
                "hours.attributetag4": "THURSDAY",
                "hours.attributetext4": "8h00-18h00",
                "hours.attributetag5": "FRIDAY",
                "hours.attributetext5": "8h00-16h00",
                "hours.attributetag6": "SATURDAY",
                "hours.attributetext6": "8h00-12h00",
                "hours.attributetag7": "SUNDAY",
                "hours.attributetext7": "Closed",

                // # 404 - Page
                "page404.title": `404 - Page Not Found - Andmar Eco-Energy ${location}`,
                "page404.maintext1": "NOT FOUND",
                "page404.maintext2": "You just hit a page that doesn't exist... the sadness.",

                // # Covid19 - priority - booking - Page
                "registerForm.title": "Register Here",
                "card2.attributetextphone": "Phone",
                "covid19.maintext1": "Your health and our employee's are important to us, due to the current situation of the Covid-19, we are holding back all of our non-essential operations. Meanwhile, do not hesitate to subscribe to our booking list, so we can schedule your appointment as soon as possible. Please note that bookings will proceed on a first come, first served basis.",




            },
            slugs: {
                '/404': '/products',
                "/solutions": "/solutions"
            }

        }
    )
}

